import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getSubcontractorPdfDocuments } from '../services/SubcontractorDocumentsService';
import { inspectionAttachmentsKeys } from './queryKeys';
import { SUBCONTRACTOR_DOCUMENT_CHANGED_EVENT } from '../../../../DocumentsList/events';
export function useSubcontractorPdfDocuments(inspectionId) {
    const queryClient = useQueryClient();
    const queryKey = inspectionAttachmentsKeys.subcontractorPdfs(inspectionId);
    useEffect(() => {
        const handler = (event) => {
            const detail = event.detail;
            if ((detail === null || detail === void 0 ? void 0 : detail.inspectionId) !== inspectionId)
                return;
            void queryClient.invalidateQueries({ queryKey });
        };
        window.addEventListener(SUBCONTRACTOR_DOCUMENT_CHANGED_EVENT, handler);
        return () => window.removeEventListener(SUBCONTRACTOR_DOCUMENT_CHANGED_EVENT, handler);
    }, [inspectionId, queryClient, queryKey]);
    return useQuery({
        queryKey,
        queryFn: () => getSubcontractorPdfDocuments(inspectionId),
        enabled: !!inspectionId,
        staleTime: 30000
    });
}
